import Button from '../../../../../components/UiElements/Button'
import DynamicForm from '../../../../../components/DynamicForm'
import React, { useEffect, useRef, useState } from 'react'
import laserProfileMapping from './dataMapping/laserProfile'

import LaserProfileForm from './LaserProfileForm'
import axios from '@/services/axios'
import ButtonList from '@/components/UiElements/ListButton'
import useStateManagement from '@/hooks/stateManagement/useStateManagement'

const LaserProfile = ({ item, data, change }) => {
  //bound, close, submit, valid
  const myFormRef = useRef(null)

  const [contentList, setContentList] = useState({}) // Changed 'React.useState' to 'useState'

  const { runSteps: createLaserProfile, stateInProgress } = useStateManagement({
    initial: {
      main: async (state, form) => {
        return {
          method: form.formData.id ? 'PUT' : 'POST',
          update: !!form.formData.id,
          mappedData: laserProfileMapping(form.formData),
          parentData: form?.parentData || '',
          contentList: form?.contentList,
          setContentList: form?.setContentList,
        }
      },
    },
    save: {
      main: async (state, form) => {
        axios('/laserprofiles/', state?.initial?.method, state?.initial?.mappedData).then((response) => {
          let parentData = state?.initial?.parentData
          if (!state?.initial?.update) {
            parentData = response?.id
          }
          if (state?.initial?.contentList?.selected) {
            const inlineList = state?.initial?.contentList?.list?.map((item) => {
              if (item.id === response?.id) {
                return form.formData
              }
              return item
            })
            state.initial.setContentList({
              list: inlineList,
              selected: response?.id,
            })
          } else {
            const inlineList = [...state?.initial?.contentList?.list, form.formData]
            console.log('inlineList-----', inlineList)
            state.initial.setContentList({
              list: inlineList,
              selected: response?.id,
            })
          }
          change(parentData, item.parent, null, null, true)
        })
      },
      startMessage: (result, state) => `${state?.initial?.update ? 'Update-' : 'SAVE-'} Laser profile ...`,
      errorMessage: (result, state) => `${state?.initial?.update ? 'Update-' : 'SAVE-'} Laser profile failed :(`,
      successMessage: (result, state) => `Laser profile ${state?.initial?.update ? 'Updated' : 'Created'} :)`,
    },
  })

  const handleFetchLaserProfile = async () => {
    axios('/laserprofiles/', 'GET').then((response) => {
      if (response?.contents) {
        const mapLoadedData = response?.contents.map((item) => ({
          ...item,
          ...item.laser_properties,
          id: item.id,
          laser_properties_id: item.laser_properties?.id,
        }))
        myFormRef.current?.setData(mapLoadedData[0])
        setContentList({
          list: mapLoadedData,
          selected: response?.contents[0]?.id,
        })
      } else {
        myFormRef.current?.setData({})
      }
    })
  }

  useEffect(() => {
    handleFetchLaserProfile()
  }, [])

  const handleSaveLaserProfile = async () => {
    const formData = await myFormRef?.current?.getData()
    console.log('formData', formData, contentList)
    if (formData) {
      await createLaserProfile({
        formData: formData,
        parentData: data?.[item.parent] || '',
        contentList: contentList,
        setContentList: setContentList,
      })
    }
  }

  const handleAddSection = () => {
    setContentList({
      list: contentList?.list,
      selected: null,
    })
    myFormRef.current?.setData({})
  }

  const handleSelectItem = (val) => {
    setContentList({
      list: contentList?.list,
      selected: val,
    })
    myFormRef.current?.setData(contentList?.list?.find((item) => item.id === val))
  }

  return (
    <div className={'flex flex-row w-[950px] '}>
      {stateInProgress && (
        <div
          className={
            'fixed top-0 left-0 w-full h-full bg-gray-600 bg-opacity-50 flex justify-center items-center z-[100]'
          }
        ></div>
      )}
      <div className={'bg-gray-100  p-xl '}>
        <div className={'w-[300px] gap-md flex-col flex'}>
          <div className={' text-title-lg text-gray-400 hidden'}>Profile List</div>
          <div className={'flex justify-center'}>
            <Button onClick={handleAddSection} className={'!rounded-full font-icon-solid w-[44px] h-[44px]'}>
              +
            </Button>
          </div>
          <div className={'flex flex-col gap-sm '}>
            {contentList ? (
              <ButtonList
                className={(selected) =>
                  `w-[100%] bg-white rounded-md border border-gray-200   p-xs hover:border-primary-500 active:shadow-focus box-border !transition-all ${
                    selected ? 'border-primary-500 border-1 shadow-select-shadow' : ''
                  }`
                }
                items={contentList?.list?.map((item, index) => ({
                  ...item,
                  value: item.id,
                  label: (
                    <div className={'flex relative flex-col text-left  gap-sm p-md'}>
                      <span className={'text-title-md capitalize'}>{item.name}</span>
                      <span className={'text-gray-400 text-sm capitalize-first'}>{item.description}</span>
                    </div>
                  ),
                  index: index,
                }))}
                selected={contentList.selected}
                onClick={(val) => {
                  handleSelectItem(val)
                }}
              />
            ) : (
              <div>loading ..</div>
            )}
          </div>
        </div>
      </div>
      <div className={'flex flex-col pt-xl  pb-xxxl px-xxxl w[562px] box-border'}>
        <div className={'grid grid-cols-12 gap-md border-b-gray-200 border-b pb-xxxl'}>
          <DynamicForm items={LaserProfileForm} defaultValues={{}} size={'md'} ref={myFormRef} />
        </div>
        <div className={'col-span-12  flex flex-col justify-end '}>
          <Button
            onClick={() => {
              handleSaveLaserProfile()
            }}
            size={'md'}
          >
            {!contentList.selected ? 'Save' : 'Update'} Laser Profile
          </Button>
        </div>
      </div>
    </div>
  )
}

const OpenLaserProfile = ({ show }) => {
  //value, onChange, data, defaultValues
  return (
    <Button
      size={'sm'}
      type={'alt'}
      className={' w-[37px] h-[37px] font-icon-solid'}
      onClick={() => {
        show()
      }}
    >
      
    </Button>
  )
}

export { LaserProfile, OpenLaserProfile }
